module.exports = __webpack_public_path__ + "static/media/AB_B2_2.97fab21b.jpg";